import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import type { ReturnsReturnProcessIdentification } from '@itsrever/rever-api'
import { returnsApiProxy } from '@/redux/api/returns-api-slice'

export const getInstructionsURLQuery = ({
  email,
  process_id
}: Partial<ReturnsReturnProcessIdentification>) =>
  queryOptions({
    queryKey: ['instructions-url', email, process_id],
    queryFn:
      email !== undefined && process_id !== undefined
        ? async () => {
            const { data } = await returnsApiProxy.instructionsPresignedURL({
              returnsInstructionsPresignedURLRequest: {
                return_process_identification: { email, process_id }
              }
            })

            return data.url ?? null
          }
        : skipToken,
    staleTime: Infinity,
    retry: false
  })

export const useInstructionsURL = (
  identification: Partial<ReturnsReturnProcessIdentification>
) => {
  return useQuery(getInstructionsURLQuery(identification))
}
